import { useQuery } from '@tanstack/vue-query'
import { fetchDepositCatalog } from '~/api/wallet'
import { useUserStore } from '~/stores/user'

/**
 * 充值目录（类型/渠道/预设/汇率）统一数据入口。
 * 所有充值相关的派生 composable 都应从此处取数据，避免重复 useQuery。
 */
export function useDepositCatalog() {
  const userStore = useUserStore()
  return useQuery({
    queryKey: ['wallet', 'deposit-catalog'],
    queryFn: fetchDepositCatalog,
    enabled: () => userStore.isLoggedIn,
    staleTime: 60_000,
    retry: false,
  })
}
